import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage', 'navigator'],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: true,
    },
  })
  .then(() => {
    const html = document.querySelector('html');
    if (html) {
      html.setAttribute('lang', i18n.language);
    }
  });

export default i18n;
